/**
 * @generated SignedSource<<e05e44ec9dc9c77b9de69d4283a83c52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NotificationNotificationType = "CONDITIONSACCEPTED" | "CONFIRMACCOUNT" | "DEPRECATED" | "DEPRECATED_80" | "EDITMODEREMINDER" | "EVALUATIONREMINDER" | "EVALUATIONSESSIONREMINDER" | "EVALUATIONSESSIONSTART" | "EXPIRATIONREMINDERTOUNANSWEREDREFERENCEVALIDATION" | "INVITETOCONCEPTEVALUATION" | "INVITETOPITCHEVALUATION" | "INVITETOREFERENCEVALIDATION" | "INVITETORFQ" | "NEWANNOUNCEMENT" | "NEWANSWERSTOQUESTIONS" | "NEWCLIENTCALLBACKWASPOSTED" | "NEWORGANIZATIONACCOUNT" | "NEWPROJECTCREATEDRFP" | "NEWPROJECTCREATEDRFQ" | "NEWPROJECTREQUEST" | "NEWPROJECTSTATUS" | "NEWPROJECTSTATUSRFQ" | "NEWPROJECTSUBMITTEDRFP" | "NEWPROJECTSUBMITTEDRFQ" | "NEWPROPOSALSUBMITTEDRFP" | "NEWPROPOSALSUBMITTEDRFQ" | "NEWQUESTIONS" | "NEWRATESSUBMITTED" | "NEWSUPPORTQUESTION" | "NEWUSERACCOUNTACTIVATED" | "NEWUSERACCOUNTCREATED" | "OVERDUEPROJECTS" | "PARTICIPATIONCANCELLEDBYVENDOR" | "PITCHEVALUATIONREMINDER" | "PITCHINVITATION" | "PITCHINVITATIONACCEPTED" | "PITCHINVITATIONDECLINED" | "PROJECTAWARDINGDUE" | "PROJECTAWARDINGDUEDATEREMINDER" | "PROJECTINVITATIONACCEPTEDRFQ" | "PROJECTREQUESTREJECTED" | "PROPOSALACCEPTED" | "PROPOSALAWARDINGCLIENTINTERNAL" | "PROPOSALAWARDINGDUE" | "PROPOSALAWARDINGDUEDATEREMINDER" | "PROPOSALAWARDINGTOSUPPLIER" | "PROPOSALCANCELLATIONBYSUPPLIER" | "PROPOSALDELETED" | "PROPOSALDISMISSED" | "PROPOSALDUEDATEREMINDER" | "PROPOSALINVITATION" | "PROPOSALLOSTMESSAGETOSUPPLIER" | "PROPOSALPARTICIPATIONCONFIRMATION" | "PROPOSALREVISIONREQUESTED" | "RATEREVISIONREQUESTED" | "RATESCONFIRMED" | "RATESREJECTED" | "RECOVERPASSWORD" | "REFERENCECANCELLED" | "REFERENCECONFIRMED" | "REFERENCEEXPIRED" | "REFERENCEPIN" | "REFERENCEREJECTED" | "REMINDERFORCONFIRMATIONOFRFQ" | "REMINDERFORCONFIRMATIONOFRRFP" | "REMINDERFORINVITETORFP" | "REMINDERFORINVITETORFQ" | "REMINDERFORPROPOSALDUEDATE" | "REMINDERTOUNANSWEREDQUESTIONS" | "REMINDERTOUNANSWEREDREFERENCEVALIDATION" | "REQUESTNEWPROPOSAL" | "SECONDREMINDERTOUNANSWEREDREFERENCEVALIDATION" | "SUCCESSFULPROPOSALSUBMISSION" | "SUCCESSFULRATECARDPROPOSALSUBMISSION" | "SUPPLIERCONFIRMSTNCS" | "SUPPLIERDISMISSEDFROMRFP" | "SUPPLIERREJECTSTNCS" | "SURVEYINVITE" | "TIMELINECHANGE" | "USERASSIGNEDTORFP" | "USERASSIGNEDTORFQ" | "%future added value";
export type NotificationContextProviderNotificationsQuery$variables = {
  first?: number | null;
};
export type NotificationContextProviderNotificationsQuery$data = {
  readonly unreadNotifications: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly context: any | null;
        readonly created: any;
        readonly id: string;
        readonly notificationType: NotificationNotificationType;
        readonly unread: boolean;
      } | null;
    } | null>;
  } | null;
  readonly userNotifications: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly context: any | null;
        readonly created: any;
        readonly id: string;
        readonly notificationType: NotificationNotificationType;
        readonly unread: boolean;
      } | null;
    } | null>;
  } | null;
};
export type NotificationContextProviderNotificationsQuery = {
  response: NotificationContextProviderNotificationsQuery$data;
  variables: NotificationContextProviderNotificationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v2 = {
  "kind": "Literal",
  "name": "orderby",
  "value": "-created"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NotificationNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationNode",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unread",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "context",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "concreteType": "NotificationNodeConnection",
    "kind": "LinkedField",
    "name": "userNotifications",
    "plural": false,
    "selections": (v3/*: any*/),
    "storageKey": null
  },
  {
    "alias": "unreadNotifications",
    "args": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "Literal",
        "name": "unread",
        "value": true
      }
    ],
    "concreteType": "NotificationNodeConnection",
    "kind": "LinkedField",
    "name": "userNotifications",
    "plural": false,
    "selections": (v3/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationContextProviderNotificationsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationContextProviderNotificationsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "c67ecfc9584a58c8568edc3d8aaa0f9e",
    "id": null,
    "metadata": {},
    "name": "NotificationContextProviderNotificationsQuery",
    "operationKind": "query",
    "text": "query NotificationContextProviderNotificationsQuery(\n  $first: Int\n) {\n  userNotifications(first: $first, orderby: \"-created\") {\n    edges {\n      node {\n        id\n        notificationType\n        created\n        unread\n        context\n      }\n    }\n  }\n  unreadNotifications: userNotifications(first: $first, unread: true, orderby: \"-created\") {\n    edges {\n      node {\n        id\n        notificationType\n        created\n        unread\n        context\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ddb2acc2caa66432506b2594b444255";

export default node;
